import { render, staticRenderFns } from "./PhoneRoot.vue?vue&type=template&id=95627636"
import script from "./PhoneRoot.vue?vue&type=script&lang=js"
export * from "./PhoneRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports